import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Package, MapPin, Clock, CheckSquare, Smartphone, Users } from 'lucide-react';
import '../styles/Pages.css';
import { Link } from 'react-router-dom';

const Delivery = () => {
  const features = [
    {
      icon: <Package size={24} />,
      title: 'Seguimiento de Entregas',
      description: 'Monitoreo en tiempo real del estado y ubicación de cada paquete desde la recogida hasta la entrega.'
    },
    {
      icon: <MapPin size={24} />,
      title: 'Optimización de Rutas',
      description: 'Cálculo de rutas óptimas para maximizar entregas y minimizar tiempos y costos.'
    },
    {
      icon: <Clock size={24} />,
      title: 'Ventanas de Entrega',
      description: 'Gestión de horarios específicos de entrega con alertas y notificaciones automáticas.'
    },
    {
      icon: <CheckSquare size={24} />,
      title: 'Prueba de Entrega',
      description: 'Captura digital de firmas, fotos y notas para confirmar entregas completadas.'
    },
    {
      icon: <Smartphone size={24} />,
      title: 'App para Repartidores',
      description: 'Aplicación móvil especializada para conductores con navegación y gestión de entregas.'
    },
    {
      icon: <Users size={24} />,
      title: 'Portal para Clientes',
      description: 'Interfaz para que los clientes puedan seguir sus pedidos en tiempo real.'
    }
  ];

  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Soluciones para Entregas</h1>
            <p>Optimiza tus servicios de entrega y mejora la experiencia de tus clientes</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="page-grid">
              <div className="page-text">
                <h2>Gestión Eficiente de Entregas</h2>
                <p>En un mercado donde la rapidez y precisión en las entregas son factores decisivos para la satisfacción del cliente, VillaTracking ofrece soluciones especializadas para empresas de reparto y última milla.</p>
                <p>Nuestra plataforma permite rastrear cada entrega en tiempo real, optimizar rutas para maximizar la eficiencia, proporcionar estimaciones precisas de entrega y recopilar pruebas digitales de entrega, todo en una solución integrada.</p>
                {/* <a href="#contact" className="btn btn-primary">Solicitar Demo</a> */}
                <Link to="/#contact" className="btn btn-primary btn-lg">
                  Solicitar Demo
                </Link>
              </div>
              <div className="page-image">
                <img src="img/delivery1.webp" alt="Entregas VillaTracking" />
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <h2 className="text-center">Características Especializadas para Entregas</h2>
            <div className="features-grid-3">
              {features.map((feature, index) => (
                <div className="feature-card" key={index}>
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="delivery-workflow">
              <h2 className="text-center">Flujo de Trabajo Optimizado</h2>
              <div className="workflow-steps">
                <div className="workflow-step">
                  <div className="workflow-number">1</div>
                  <div className="workflow-content">
                    <h3>Planificación de Rutas</h3>
                    <p>El sistema calcula automáticamente las rutas más eficientes considerando múltiples factores como ubicaciones de entrega, tráfico y ventanas horarias.</p>
                  </div>
                </div>
                
                <div className="workflow-step">
                  <div className="workflow-number">2</div>
                  <div className="workflow-content">
                    <h3>Asignación de Tareas</h3>
                    <p>Los conductores reciben sus rutas y tareas directamente en la aplicación móvil, con toda la información necesaria para cada entrega.</p>
                  </div>
                </div>
                
                <div className="workflow-step">
                  <div className="workflow-number">3</div>
                  <div className="workflow-content">
                    <h3>Seguimiento en Tiempo Real</h3>
                    <p>Tanto los administradores como los clientes pueden seguir el progreso de las entregas en tiempo real a través de mapas interactivos.</p>
                  </div>
                </div>
                
                <div className="workflow-step">
                  <div className="workflow-number">4</div>
                  <div className="workflow-content">
                    <h3>Confirmación de Entrega</h3>
                    <p>Los conductores registran la entrega mediante firma digital, fotografía o código QR, proporcionando prueba inmediata de la entrega completada.</p>
                  </div>
                </div>
                
                <div className="workflow-step">
                  <div className="workflow-number">5</div>
                  <div className="workflow-content">
                    <h3>Análisis y Mejora</h3>
                    <p>El sistema genera informes detallados sobre rendimiento, permitiendo identificar áreas de mejora y optimizar continuamente las operaciones.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <div className="page-grid">
              <div className="page-image">
                <img src="img/delivery2.webp" alt="App para Repartidores" />
              </div>
              <div className="page-text">
                <h2>Aplicación Móvil para Repartidores</h2>
                <p>Nuestra aplicación móvil especializada para repartidores está diseñada para simplificar y agilizar el proceso de entrega, proporcionando todas las herramientas necesarias en un solo lugar.</p>
                <ul className="feature-list">
                  <li>Navegación paso a paso con rutas optimizadas</li>
                  <li>Lista de tareas organizada por prioridad y ubicación</li>
                  <li>Captura de firmas, fotos y notas como prueba de entrega</li>
                  <li>Comunicación directa con el centro de operaciones</li>
                  <li>Funcionamiento offline para áreas sin cobertura</li>
                  <li>Notificaciones automáticas a clientes sobre estado de entregas</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="metrics-section">
              <h2 className="text-center">Resultados Que Puedes Esperar</h2>
              <div className="metrics-grid">
                <div className="metric-card">
                  <div className="metric-value">25%</div>
                  <div className="metric-label">Aumento en entregas diarias</div>
                </div>
                
                <div className="metric-card">
                  <div className="metric-value">30%</div>
                  <div className="metric-label">Reducción en costos de combustible</div>
                </div>
                
                <div className="metric-card">
                  <div className="metric-value">98%</div>
                  <div className="metric-label">Precisión en tiempos estimados</div>
                </div>
                
                <div className="metric-card">
                  <div className="metric-value">40%</div>
                  <div className="metric-label">Menos llamadas de seguimiento</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-cta">
          <div className="container">
            <h2>Lleva tus servicios de entrega al siguiente nivel</h2>
            <p>Descubre cómo VillaTracking puede transformar tus operaciones de entrega</p>
            <Link to="/#contact" className="btn btn-primary btn-lg">Solicitar Demo</Link>            
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Delivery;